<template>
  <div id="CheckOutResult">
    <span>THNAK YOU</span>
    <h2>感謝您的購買，訂單已建立</h2>
    <p v-html="msg"></p>
    <div>
      <a href="https://lin.ee/MUlVeVn" class="line_btn">加入官方LINE@</a>
      <router-link class="back_btn" to="/">回到首頁</router-link>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "PayError",
  data() {
    return {
      msg: "",
    };
  },
  methods: {
    async GetOrder() {
      if (
        this.$route.query.order_id &&
        this.$route.query.name &&
        this.$route.query.phone &&
        this.$route.query.email
      ) {
        let result = await this.SendPostData(
          process.env.VUE_APP_BASE_API + "orders/get_order.php",
          qs.stringify({
            order_id: this.$route.query.order_id,
            name: this.$route.query.name,
            phone: this.$route.query.phone,
            email: this.$route.query.email,
          })
        );
        if (result.status != "error") {
          let order_data = JSON.parse(result.data);
          if (order_data.ga_record == "N") {
            this.SetGaEvent(order_data);
          }
        }
      }
    },
    async SetGaEvent(order_data) {
      this.GA_Purchase(order_data);
      await this.SendPostData(
        process.env.VUE_APP_BASE_API + "orders/update_order_ga_record.php",
        qs.stringify({
          order_id: order_data.order_id,
          status: "Y",
        })
      );
    },
  },
  created() {
    // this.SetShopCart([])
    if (this.$route.params.type == "after_pay") {
      this.msg =
        "等待訂單內容確認無誤後我們將盡快為您出貨<br>詳細的訂單資訊可以查看您的Email或使用<a href='/search_order'>訂單查詢</a><br><br>歡迎加入官方LINE@已獲得最新活動、優惠資訊以及更即時的客服服務！";
    } else {
      this.msg =
        "等待您完成付款後，我們將會核對訂單內容並盡快為您安排出貨<br>詳細的訂單資訊可以查看您的Email或使用<a href='/search_order'>訂單查詢</a><br><br><b>歡迎加入官方LINE@已獲得最新活動、優惠資訊以及更即時的客服服務！</b>";
    }
    // this.GetOrder()
  },

  metaInfo() {
    return {
      title: "訂單結果｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content: "有任何訂單相關的疑問歡迎來電或來訊與我們聯絡",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content: "有任何訂單相關的疑問歡迎來電或來訊與我們聯絡",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content: "有任何訂單相關的疑問歡迎來電或來訊與我們聯絡",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "訂單結果｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "訂單結果｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "訂單結果｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
